'use strict';

var processInclude = require('base/util');
var thumbnailSelection = require('./product/detail').thumbnailSelection;

$(document).ready(function () {
    processInclude(require('./product/quickView'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./product/notifyme'));
    thumbnailSelection();
});
